const sandbox = 'https://sandbox.tinypass.com';
const production = 'https://cdn-eu.piano.tinypass.com';
export const pianoUrls = [ sandbox, production ];
export default pianoUrls;
